(function () {
  if (window.__hngCollectionLoaded) return;
  window.__hngCollectionLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealObserver = null;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* —— Hero —— */
  function initHero(root) {
    if (!root || root.dataset.hngHeroBound === '1') return;
    root.dataset.hngHeroBound = '1';

    var track = root.querySelector('[data-hng-hero-track]');
    var slides = root.querySelectorAll('[data-hng-hero-slide]');
    if (!track || slides.length < 2) return;

    var index = 0;
    var timer = null;
    var delay = parseInt(root.getAttribute('data-autoplay') || '3000', 10);

    function setActive(i) {
      slides.forEach(function (slide, n) {
        var on = n === i;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }

    function go(n) {
      index = (n + slides.length) % slides.length;
      track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
      setActive(index);
    }

    function next() { go(index + 1); }
    function prev() { go(index - 1); }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      if (reduceMotion.matches || delay <= 0) return;
      stop();
      timer = window.setInterval(next, delay);
    }

    root.querySelectorAll('[data-hng-hero-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { next(); start(); });
    });
    root.querySelectorAll('[data-hng-hero-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { prev(); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    go(0);
    start();
  }

  /* —— Rails —— */
  function initRail(root) {
    if (!root || root.dataset.hngRailBound === '1') return;
    root.dataset.hngRailBound = '1';

    var track = root.querySelector('[data-hng-rail-track]');
    if (!track) return;
    var prev = root.querySelector('[data-hng-rail-prev]');
    var next = root.querySelector('[data-hng-rail-next]');
    var smooth = !reduceMotion.matches;

    track.setAttribute('tabindex', '0');
    track.setAttribute('role', 'region');
    if (!track.getAttribute('aria-label')) {
      track.setAttribute('aria-label', 'Product carousel');
    }

    function step() {
      var card = track.querySelector('.hng-card');
      if (!card) return 280;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    function move(dir) {
      track.scrollBy({ left: dir * step(), behavior: smooth ? 'smooth' : 'auto' });
    }

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); move(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); move(-1); }
    });
    window.addEventListener('resize', update);
    update();
  }

  function initStores(root) {
    if (!root || root.dataset.hngStoresBound === '1') return;
    root.dataset.hngStoresBound = '1';

    var track = root.querySelector('[data-hng-stores-track]');
    if (!track) return;
    var prev = root.querySelector('[data-hng-stores-prev]');
    var next = root.querySelector('[data-hng-stores-next]');
    var smooth = !reduceMotion.matches;

    function step() {
      var card = track.querySelector('.hng-stores__card');
      if (!card) return 320;
      return card.getBoundingClientRect().width + 16;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: smooth ? 'smooth' : 'auto' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: smooth ? 'smooth' : 'auto' });
    });
  }

  /* —— Motion reveals —— */
  function prime(el, type, delay) {
    if (!el || el.dataset.hngMotionReady === 'true') return;
    el.dataset.hngMotionReady = 'true';
    el.classList.add('hng-motion-reveal', 'hng-motion-' + (type || 'copy'));
    el.style.setProperty('--hng-motion-delay', (delay || 0) + 'ms');

    if (reduceMotion.matches) {
      el.classList.add('is-visible');
      return;
    }
    el.classList.add('hng-motion-primed');
  }

  function reveal(el) {
    if (!el) return;
    el.classList.add('is-visible');

    function clearPrime(event) {
      if (event && event.propertyName && event.propertyName !== 'transform' && event.propertyName !== 'opacity') {
        return;
      }
      el.removeEventListener('transitionend', clearPrime);
      el.classList.remove('hng-motion-primed');
    }

    el.addEventListener('transitionend', clearPrime);
    window.setTimeout(clearPrime, 1100);
  }

  function observe(el) {
    if (!el) return;
    if (reduceMotion.matches) {
      reveal(el);
      return;
    }
    if (revealObserver) revealObserver.observe(el);
    else reveal(el);
  }

  function setupMotion() {
    if (revealObserver && revealObserver.disconnect) revealObserver.disconnect();

    if ('IntersectionObserver' in window && !reduceMotion.matches) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          revealObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
      });
    } else {
      revealObserver = {
        disconnect: function () {},
        observe: reveal,
        unobserve: function () {}
      };
    }

    // Signature: hero opening
    var heroCopy = document.querySelector('.hng-hero .hng-hero__slide.is-active .hng-hero__copy, .hng-hero .hng-hero__slide:first-child .hng-hero__copy');
    var heroMedia = document.querySelector('.hng-hero .hng-hero__slide.is-active .hng-hero__media, .hng-hero .hng-hero__slide:first-child .hng-hero__media');
    prime(heroCopy, 'copy', 40);
    prime(heroMedia, 'media', 0);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        reveal(heroMedia);
        reveal(heroCopy);
      });
    });

    // Featured lifestyle + cards
    var featHero = document.querySelector('.hng-featured__hero');
    prime(featHero, 'media', 0);
    observe(featHero);

    document.querySelectorAll('.hng-featured__cards .hng-card').forEach(function (card, i) {
      prime(card, 'copy', Math.min(i * 55, 220));
      observe(card);
    });

    // Closer look
    var closer = document.querySelector('.hng-closer');
    prime(closer, 'media', 0);
    observe(closer);

    // Row cards
    document.querySelectorAll('.hng-row .hng-card').forEach(function (card, i) {
      prime(card, 'copy', Math.min(i * 50, 180));
      observe(card);
    });

    // Lifestyle panels
    document.querySelectorAll('.hng-life__item').forEach(function (item, i) {
      prime(item, 'media', Math.min(i * 70, 140));
      observe(item);
    });

    // Rail
    var rail = document.querySelector('.hng-rail');
    prime(rail, 'copy', 0);
    observe(rail);

    // Stores
    var storesHead = document.querySelector('.hng-stores__head');
    var storesIntro = document.querySelector('.hng-stores__intro');
    prime(storesIntro, 'copy', 0);
    prime(storesHead, 'copy', 40);
    observe(storesIntro);
    observe(storesHead);

    document.querySelectorAll('.hng-stores__card').forEach(function (card, i) {
      prime(card, 'copy', Math.min(i * 60, 180));
      observe(card);
    });
  }

  function boot() {
    document.querySelectorAll('[data-hng-hero]').forEach(initHero);
    document.querySelectorAll('[data-hng-rail]').forEach(initRail);
    document.querySelectorAll('[data-hng-stores]').forEach(initStores);
    setupMotion();
  }

  onReady(boot);
  document.addEventListener('shopify:section:load', boot);
})();
